import type { IUserInfo } from "@/account/account-models";
import type { IChatInfo } from "@/chats/chats-models";
import type { IGetFeedConfig } from "@/feed/feed-helpers";
import { createAction } from "@reduxjs/toolkit";
import type { IGetProfileFeedResponse } from "./model-profile-api";

export namespace IModelProfileActions {
  export enum Type {
    GET__PROFILE_USER__INIT = "GET__PROFILE_USER__INIT",
    GET__PROFILE_USER__SUCCESS = "GET__PROFILE_USER__SUCCESS",
    GET__PROFILE_USER__FAILURE = "GET__PROFILE_USER__FAILURE",
    GET__PROFILE_USER__RESET = "GET__PROFILE_USER__RESET",

    GET__PROFILE_FEED__INIT = "GET__PROFILE_FEED__INIT",
    GET__PROFILE_FEED__SUCCESS = "GET__PROFILE_FEED__SUCCESS",
    GET__PROFILE_FEED_PHOTOS__INIT = "GET__PROFILE_FEED_PHOTOS__INIT",
    GET__PROFILE_FEED_PHOTOS__SUCCESS = "GET__PROFILE_FEED_PHOTOS__SUCCESS",
    GET__PROFILE_FEED_VIDEOS__INIT = "GET__PROFILE_FEED_VIDEOS__INIT",
    GET__PROFILE_FEED_VIDEOS__SUCCESS = "GET__PROFILE_FEED_VIDEOS__SUCCESS",
    GET__PROFILE_FEED__RESET = "GET__PROFILE_FEED__RESET",

    GET__PROFILE_CHAT__INIT = "GET__PROFILE_CHAT__INIT",
    GET__PROFILE_CHAT__SUCCESS = "GET__PROFILE_CHAT__SUCCESS",
    GET__PROFILE_CHAT__RESET = "GET__PROFILE_CHAT__RESET",

    // Applies the optimistic is_followee flip that patchFollow/deleteFollow's
    // onQueryStarted dispatches on success (modelProfileApi owns their
    // request tracking).
    SET_PROFILE_USER_FOLLOWED = "SET_PROFILE_USER_FOLLOWED",
  }

  export const initGetProfileUser = createAction<IUserInfo | undefined>(
    Type.GET__PROFILE_USER__INIT
  );
  export const successGetProfileUser = createAction<IUserInfo>(
    Type.GET__PROFILE_USER__SUCCESS
  );
  export const failureGetProfileUser = createAction<unknown>(
    Type.GET__PROFILE_USER__FAILURE
  );
  export const resetGetProfileUser = createAction(
    Type.GET__PROFILE_USER__RESET
  );

  export const initGetProfileFeed = createAction<{ config: IGetFeedConfig }>(
    Type.GET__PROFILE_FEED__INIT
  );
  export const successGetProfileFeed = createAction<{
    config: IGetFeedConfig;
    res: IGetProfileFeedResponse;
  }>(Type.GET__PROFILE_FEED__SUCCESS);
  export const initGetProfileFeedPhotos = createAction<{
    config: IGetFeedConfig;
  }>(Type.GET__PROFILE_FEED_PHOTOS__INIT);
  export const successGetProfileFeedPhotos = createAction<{
    config: IGetFeedConfig;
    res: IGetProfileFeedResponse;
  }>(Type.GET__PROFILE_FEED_PHOTOS__SUCCESS);
  export const initGetProfileFeedVideos = createAction<{
    config: IGetFeedConfig;
  }>(Type.GET__PROFILE_FEED_VIDEOS__INIT);
  export const successGetProfileFeedVideos = createAction<{
    config: IGetFeedConfig;
    res: IGetProfileFeedResponse;
  }>(Type.GET__PROFILE_FEED_VIDEOS__SUCCESS);
  export const resetGetProfileFeed = createAction(
    Type.GET__PROFILE_FEED__RESET
  );

  export const initGetProfileChat = createAction<{
    cachedChat?: IChatInfo;
  }>(Type.GET__PROFILE_CHAT__INIT);
  export const successGetProfileChat = createAction<IChatInfo>(
    Type.GET__PROFILE_CHAT__SUCCESS
  );
  export const resetGetProfileChat = createAction(
    Type.GET__PROFILE_CHAT__RESET
  );

  export const setProfileUserFollowed = createAction<boolean>(
    Type.SET_PROFILE_USER_FOLLOWED
  );
}

export type ModelProfileActions = Omit<typeof IModelProfileActions, "Type">;
